import { connect } from 'react-redux';
import { pipe, prop } from 'ramda';
import { withProps, withHandlers, compose, branch, renderNothing } from 'recompose';
import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import OrangeLink from './OrangeLink';
import { trackMyAdsClick } from '../services/tracking';

const shouldShow = pipe(
  getPOSData,
  prop('limitExceeded'),
);

const configureHandlers = withHandlers({
  handleClick: ({
    adId, listId, pointOfSale, funnelId,
  }) => () => {
    trackMyAdsClick(adId, listId, pointOfSale, funnelId);
  },
});

const mapStateToProps = (state) => {
  const posData = getPOSData(state);

  return {
    pointOfSale: prop('name', posData),
    funnelId: prop('funnelId', posData),
    adId: prop('adId', posData),
    listId: prop('listId', posData),
    hidden: shouldShow(state),
  };
};

const visibilityCheck = branch(
  ({ hidden }) => hidden,
  renderNothing,
);

const MYADS_URL = 'https://www3.olx.com.br/account/userads';
const isInsertion = () => document.location.search.match(/action=insertion/);

const configureTarget = withProps({
  type: 'secondary',
  href: isInsertion() ? `${MYADS_URL}?under_review=1` : MYADS_URL,
  'data-e2e': 'exitButton',
});

export default compose(
  connect(mapStateToProps),
  configureTarget,
  visibilityCheck,
  configureHandlers,
)(OrangeLink);
